import { Box, Grid } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as ROUTES from '../../../router/Routes';
import { DrawerWidget, ModalComponent } from '../../../widgets';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import {
  allFamiliaresAction,
  setActivoFamiliaresAction,
} from './FamiliaresAction';
import FiltrosFamiliaresComponent from './components/FiltrosFamiliares';
import FormFamiliarComponent from './components/FormFamiliares';
import ListadoFamiliares from './components/ListadoFamiliares';

const FamiliaresView = () => {
  const dispatch = Redux.useDispatch();
  let history = useHistory();

  const familiaresStore = Redux.useSelector((state) => state.familiares);

  const [openModalForm, setOpenModalForm] = React.useState(false);
  const [isFiltros, setIsFiltros] = React.useState(false);

  // React.useEffect(() => {
  // if (!familiaresStore.params.idSeccion) {
  //   setIsFiltros(true);
  // }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  return (
    <Grid container spacing={1}>
      <Grid
        item
        md={12}
        sx={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <Box>
          <BotonComponent
            click={async () => {
              await setActivoFamiliaresAction(dispatch, null);
              setOpenModalForm(true);
            }}
            green
            mr={2}
            addIcon
          />
          <BotonComponent
            click={async () => {
              await setActivoFamiliaresAction(dispatch, null);
              await allFamiliaresAction(dispatch, familiaresStore.params);
            }}
            disabled={familiaresStore.loadingAll}
            white
            refreshIcon
            text={familiaresStore.loadingAll ? 'Actualizando...' : 'Actualizar'}
            mr={2}
          />
          {familiaresStore.params.idSeccion && (
            <BotonComponent
              text="EXPORTAR PDF"
              click={() => {
                history.push(ROUTES.familiaresPdf.to);
              }}
              red
              downloadIcon
              mr={2}
            />
          )}
        </Box>
        <BotonComponent
          text={`FILTROS ${isFiltros ? 'ACTIVO' : ''}`}
          filterIcon
          click={() => setIsFiltros(!isFiltros)}
          white={!isFiltros}
          blue={isFiltros}
          me={2}
        />
      </Grid>
      <Grid item md={12}>
        <ListadoFamiliares setOpenModalForm={(val) => setOpenModalForm(val)} />
      </Grid>
      <DrawerWidget open={isFiltros} onClose={(val) => setIsFiltros(val)}>
        <FiltrosFamiliaresComponent />
      </DrawerWidget>
      <ModalComponent
        id="modalFormFamiliares"
        title="Nuevo familiar"
        open={openModalForm}
        maxWidth="lg"
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormFamiliarComponent
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </ModalComponent>
    </Grid>
  );
};

export default FamiliaresView;
